import {
  isPrimitive,
  isPrimitiveArray,
  isPrimitiveMap,
} from '@smartsheet-dataflow/formjs';
import { ParamModel } from '../params/ParamModelTypes';
import {
  GroupParamSchema,
  MapParamSchema,
  ParamSchema,
  ParamSchemaTypes,
  HtmlLinkParamSchema,
} from '../params/ParamSchemaTypes';
import { ModuleModel } from './ModuleModelTypes';

const isGroupParamSchema = (schema: ParamSchema): schema is GroupParamSchema =>
  schema.type === 'PARAM';

const isMapParamSchema = (schema: ParamSchema): schema is MapParamSchema =>
  schema.type === 'MAP';

const isHtmlLinkSchema = (schema: ParamSchema): schema is HtmlLinkParamSchema =>
  schema.type === 'HTML.LINK';

export const expandModel = (
  model: ParamModel,
  schemas: ParamSchema[]
): ModuleModel =>
  Object.keys(model).reduce((params, key) => {
    const value = model[key];
    const schema = schemas.find(({ param }) => param === key);
    if (schema !== undefined) {
      if (isHtmlLinkSchema(schema)) {
        return {
          ...params,
          [key]: {
            isArray: false,
            type: schema.type,
            value,
          },
        };
      } else if (isPrimitiveArray(value)) {
        return {
          ...params,
          [key]: {
            isArray: true,
            type: schema.type,
            value,
          },
        };
      } else if (isPrimitive(value)) {
        return {
          ...params,
          [key]: {
            isArray: false,
            type: schema.type,
            value: typeof value === 'boolean' ? value : `${value}`,
          },
        };
      } else if (isMapParamSchema(schema) && isPrimitiveMap(value)) {
        return {
          ...params,
          [key]: {
            isArray: false,
            type: schema.type,
            value,
          },
        };
      } else if (isGroupParamSchema(schema)) {
        if (Array.isArray(value)) {
          return {
            ...params,
            [key]: {
              isArray: true,
              type: ParamSchemaTypes.PARAM,
              value: value.map(v => expandModel(v, schema.valueParams)),
            },
          };
        } else {
          return {
            ...params,
            [key]: {
              isArray: false,
              type: ParamSchemaTypes.PARAM,
              value: expandModel(value as ParamModel, schema.valueParams),
            },
          };
        }
      }
    }
    return params;
  }, {});
